const resources = {
    representative: 'Representatives or Beauty Advisors are available:',
    monSunTime: '5am - 9pm PT',
    monSun: 'MON-SUN',
    chatWithUs: 'Chat with Us'
};

module.exports = function getResource(label) {
    return resources[label];
};
